import { render, staticRenderFns } from "./HTMLLayoutEditor.vue?vue&type=template&id=ef5708d4"
import script from "./HTMLLayoutEditor.vue?vue&type=script&lang=js"
export * from "./HTMLLayoutEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports